import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import {
  FETCH_COLLATED_FAILURE,
  FETCH_COLLATED_REQUEST,
  FETCH_COLLATED_SUCCESS
} from "../types";

const fetchCollated = id => async (dispatch, getState, { api, schema }) => {
  try {
    dispatch(createAction(FETCH_COLLATED_REQUEST)());
    const response = await api.factoring.getCollated(id);
    const data = normalize(
      { id: `${id}-collated`, ...response },
      schema.factoring_document
    );
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_COLLATED_SUCCESS)({
        [id]: data.result
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_COLLATED_FAILURE)(err));
    throw err;
  }
};

export default fetchCollated;
